<template>
  <Modal :title="'Dodeli nalog'" @close="$emit('close')">
    <div class="row">
      <div class="col-lg-3">
        <h6>
          {{ orderForAssignment?.orderNumber }} <small class="text-muted">{{ orderForAssignment?.subject }}</small>
        </h6>
        <h4>{{ orderForAssignment?.facilityName }}</h4>
      </div>
      <div class="col-lg-9">
        <NearbyServiceOrders ref="nearbyOrders" :centerOrder="orderForAssignment" />
      </div>
    </div>
    <hr />
    <div class="row mb-3 mt-3">
      <label class="col-form-label col-sm-3">Izberi delavca</label>
      <div class="col-sm-9">
        <SelectEntity apiEntity="DropDown/Workers" v-model="selectedWorkerId" @selected="onWorkerSelected" />
      </div>
    </div>
  </Modal>
</template>

<script setup>
import { ref, watch } from "vue"
import { useAuth } from "../composition-api/useAuth"
import SelectEntity from "../components/SelectEntity.vue"
import NearbyServiceOrders from "../components/NearbyServiceOrders.vue"
import { setError, setSuccess, startLoading, stopLoading } from "../components/Notification"
import { assignOrderAsync } from "../api"

defineOptions({ name: "ModalAssignWorkOrderSimple" })

const props = defineProps({
  orderForAssignment: {
    type: Object,
    default: null,
  },
})

const emit = defineEmits(["close", "assigned"])

const { fetchAuthAsync } = useAuth()
const selectedWorkerId = ref("")
const nearbyOrders = ref(null)

watch(
  () => props.orderForAssignment,
  () => (selectedWorkerId.value = ""),
)

const onWorkerSelected = async (worker) => {
  if (!worker?.id) {
    return
  }
  startLoading("ModalAssignWorkOrderSimple")
  try {
    const orderIds = new Set((nearbyOrders.value?.orders ?? []).filter((o) => o.selected).map((o) => o.id))
    orderIds.add(props.orderForAssignment.id)
    let success = 0
    await Promise.all(
      Array.from(orderIds).map(async (id) => {
        const result = await assignOrderAsync(fetchAuthAsync, worker.id, id)
        if (result) {
          success++
        }
      }),
    )
    if (success > 0) {
      setSuccess(success > 1 ? "Nalogi dodeljeni. " + success + " nalogov." : "Nalog dodeljen.")
      emit("close")
      emit("assigned")
    }
  } catch (e) {
    setError(e)
  }
  stopLoading("ModalAssignWorkOrderSimple")
}
</script>
